import React from "react";
import { ArrowUpRight, FileText, MessageSquareText, Plus, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";

const TemplateEmpty = () => {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-[440px] items-center justify-center px-5 py-8">
      <div className="relative w-full max-w-[620px] overflow-hidden rounded-[24px] border border-dashed border-[#bfd8e3] bg-[linear-gradient(135deg,rgba(255,255,255,0.92),rgba(237,248,253,0.75))] px-6 py-9 text-center dark:border-[#315364] dark:bg-[linear-gradient(135deg,rgba(18,36,46,0.94),rgba(20,45,56,0.78))]">
        <div className="pointer-events-none absolute -right-12 -top-12 h-36 w-36 rounded-full bg-[#8dd4ef]/20 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-16 -left-10 h-36 w-36 rounded-full bg-[#8eddbb]/15 blur-3xl" />

        <div className="relative mx-auto flex h-16 w-16 items-center justify-center">
          <div className="absolute inset-0 rounded-[20px] border border-dashed border-[#86bfd5]" />
          <div className="flex h-11 w-11 items-center justify-center rounded-[14px] border border-[#b9dff0] bg-[#edf8fd] text-[#147db5] shadow-[0_10px_25px_rgba(20,125,181,0.12)] dark:border-[#28516a] dark:bg-[#142a36] dark:text-[#6fc5eb]">
            <FileText size={19} strokeWidth={1.8} />
          </div>
          <Sparkles size={12} className="absolute -right-1 top-0 text-[#a96119] dark:text-[#e2ad6c]" />
        </div>

        <div className="relative mt-5">
          <h2 className="text-[18px] font-bold tracking-[-0.035em] text-[#173448] dark:text-[#edf6f9]">No templates found</h2>
          <p className="mx-auto mt-2 max-w-[440px] text-[11px] font-medium leading-5 text-[#718793] dark:text-[#8099a6]">
            Create your first WhatsApp template to keep approved marketing, utility and authentication messages ready for every conversation.
          </p>
        </div>

        <div className="relative mt-5 flex flex-wrap items-center justify-center gap-2 text-[8px] font-bold text-[#6a8290] dark:text-[#8da5b2]">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-[#d3e3e9] bg-white/70 px-2.5 py-1.5 dark:border-[#31505f] dark:bg-[#142832]">
            <MessageSquareText size={10} className="text-[#147db5]" />
            Meta-approved content
          </span>
          <span className="inline-flex items-center gap-1.5 rounded-full border border-[#d3e3e9] bg-white/70 px-2.5 py-1.5 dark:border-[#31505f] dark:bg-[#142832]">
            <ArrowUpRight size={10} className="text-[#20a777]" />
            Ready for conversations
          </span>
        </div>

        <button
          type="button"
          onClick={() => navigate("/templates/create")}
          className="group relative mt-6 inline-flex h-11 items-center justify-center gap-2 rounded-xl bg-[linear-gradient(135deg,#126f9f,#1a9bc5)] px-4 text-[10px] font-bold text-white shadow-[0_10px_24px_rgba(18,111,159,0.2)] transition-all hover:-translate-y-0.5 hover:shadow-[0_14px_30px_rgba(18,111,159,0.26)]"
        >
          <Plus size={14} strokeWidth={2.3} />
          Create template
          <ArrowUpRight size={12} className="transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
        </button>
      </div>
    </div>
  );
};

export default TemplateEmpty;
